module.exports = __webpack_public_path__ + "img/test2.f21b029b.png";